module.exports = __webpack_public_path__ + "img/m5-4.b040bcd0.png";